import React, { useState } from 'react'
import { Redirect } from 'react-router'
import { useDispatch } from 'react-redux'
import flowRight from 'lodash/flowRight'
import get from 'lodash/get'

import { Loading } from '@fielded/shared-ui'

import { withApi } from '../../../../../../common/ApiProvider'
import { withUser } from '../../../../../../common/AuthenticationProvider'
import withConfig from '../../../../../../van-shared/hoc/withConfig'
import withShipment from '../../../../common/WithShipmentWrapper'
import { isEPNWarehouse } from '../../../../common/utils'
import { onGetGeolocation, useGeolocation } from '../../../../../../van-shared/hooks/useGeolocation'
import PSMDeliveryLocation from './PSMDeliveryLocation'
import { SHIPMENT_STATUS } from '@fielded/fs-api/lib/shipment/constants'

const PSMDeliveryLocationContainer = ({
  api,
  user,
  config,
  match,
  history,
  shipment
}) => {
  const dispatch = useDispatch()

  const {
    distance,
    geolocationData,
    loading,
    locationObject
  } = useGeolocation(api, shipment)

  const [isBottomDrawerOpen, setIsBottomDrawerOpen] = useState(false)
  const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false)
  const [isRequestingPermission, setIsRequestingPermission] = useState(false)

  const {
    geoPosition,
    position,
    newPermission,
    positionErrorMsg,
    watchId
  } = geolocationData

  const isWarehouseUser = isEPNWarehouse({user, config})
  const otpKey = get(shipment, 'otp.key', { version: 'v1' })
  const snapshotId = get(shipment, 'snapshotId')

  const isShipmentReceived = shipment.status === SHIPMENT_STATUS.RECEIVED
  const skipGPSValidation = get(shipment, 'isGpsAuthenticated', false) || !!(get(shipment, 'gpsValidationFailComment.reason', false))
  const skipOTPValidation = get(shipment, 'otp.hasKeyAndPassword', false) || get(shipment, 'otp.userFailReason', '')
  const skipGPSAndOTPValidation = !isShipmentReceived && skipGPSValidation && skipOTPValidation

  const onOpenBottomDrawer = () => {
    setIsBottomDrawerOpen(true)
  }

  const onCloseBottomDrawer = () => {
    setIsBottomDrawerOpen(false)
  }

  const onOpenPermissionModal = () => {
    setIsPermissionModalOpen(true)
  }

  const onClosePermissionModal = () => {
    setIsRequestingPermission(false)
    setIsPermissionModalOpen(false)
  }

  const onRequestLocationPermission = async () => {
    setIsRequestingPermission(true)

    const callback = () => {
      onOpenBottomDrawer()
      onClosePermissionModal()
    }

    await onGetGeolocation({
      permission: newPermission,
      dispatch,
      watchId,
      callback
    })
  }

  if (skipGPSAndOTPValidation) {
    return <Redirect to={`/shipments/pick-list/${snapshotId}`} />
  }

  if (loading || !locationObject) {
    return <Loading loadingText='Loading facility details...' />
  }

  return (
    <PSMDeliveryLocation
      api={api}
      otpKey={otpKey}
      skipGPSValidation={skipGPSValidation}
      history={history}
      watchId={watchId}
      shipment={shipment}
      snapshotId={snapshotId}
      permission={newPermission}
      geoPosition={geoPosition}
      position={position}
      distance={distance}
      locationObject={locationObject}
      positionErrorMsg={positionErrorMsg}
      isBottomDrawerOpen={isBottomDrawerOpen}
      isPermissionModalOpen={isPermissionModalOpen}
      isRequestingPermission={isRequestingPermission}
      onOpenBottomDrawer={onOpenBottomDrawer}
      onCloseBottomDrawer={onCloseBottomDrawer}
      onOpenPermissionModal={onOpenPermissionModal}
      onClosePermissionModal={onClosePermissionModal}
      onRequestLocationPermission={onRequestLocationPermission}
      isWarehouseUser={isWarehouseUser}
    />
  )
}

const withHOCs = flowRight(
  withApi,
  withUser,
  withConfig,
  withShipment
)

export default withHOCs(PSMDeliveryLocationContainer)
